// extracted by css-extract-rspack-plugin
export default {"fallback":"ZTaQdCXdMKoTC_Ev","pulse":"TZjRbUPYQvktw4Tw","fullscreen":"RwPbaYE6NhMoxfhO"};